<template>
  <v-list class="product-menu">
    <v-list-item-group v-model="item" active-class="active-list-item">
      <template v-for="(menu, index) in menus">
        <v-list-item
          v-if="activeItem.product_family!=='cannabis' && menu.display_only!=='cannabis'"
          :key="index"
          @click="changeActiveComponent(menu.component, index)"
        >
          <v-list-item-title>{{menu.name}}</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="activeItem.product_family==='cannabis'"
          :key="index"
          @click="changeActiveComponent(menu.component, index)"
        >
          <v-list-item-title>{{menu.name}}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list-item-group>
  </v-list>
</template>
<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      item: 0,
      menus: [
        {
          name: 'Profile',
          component: 'ProductProfile',
          display_only: ''
        },
        {
          name: 'Image',
          component: 'ProductImage',
          display_only: ''
        },
        {
          name: 'Attributes',
          component: 'ProductAttribute',
          display_only: 'cannabis'

        },
        {
          name: 'Terpenes',
          component: 'ProductTerpene',
          display_only: 'cannabis'

        },
        {
          name: 'Aromas',
          component: 'ProductAroma',
          display_only: ''
        },
        // {
        //   name: 'Colours',
        //   component: 'ProductColor',
        //   display_only: ''
        // },
        // {
        //   name: 'Flavor',
        //   component: 'ProductFlavour',
        //   display_only: ''
        // },
        // {
        //   name: 'Moods',
        //   component: 'ProductMood',
        //   display_only: 'cannabis'

        // },
        // {
        //   name: 'Allergens',
        //   component: 'ProductAllergen',
        //   display_only: ''
        // },
        // {
        //   name: 'Variants',
        //   component: 'ProductVariant',
        //   display_only: ''
        // },
        {
          name: 'THC/CBD',
          component: 'ProductCbd',
          display_only: 'cannabis'
        }
      ]
    }
  },
  mounted() {
    try {
      if (this.activeComponent) {
        this.item = _.findIndex(this.menus, ['component', this.activeComponent])
        this.setActiveComponent(this.activeComponent)
      }
    } catch (err) {

    }
  },
  computed: {
    ...mapGetters({
      activeComponent: 'product/activeComponent',
      activeItem: 'product/activeItem'
    })
  },
  methods: {
    changeActiveComponent(component, index) {
      this.item = index
      this.setActiveComponent(component)
    },
    ...mapActions({
      setActiveComponent: 'product/setActiveComponent'
    })
  }
}
</script>
<style scoped>
.product-menu .active-list-item {
  background-color: #e0ffae;
  color: #70aa1e;
}
</style>
